import styled from '@emotion/styled';
import { List } from '@mui/material';

export const StyledAside = styled('aside')(
  () => `
  width: 300px;
  height: 100vh;
  background: #233044;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: auto;
`,
);

export const StyledAsideLogo = styled('aside')(
  () => `
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    width: 92px;
    height: 32px;
    background: url(/logo.svg) no-repeat center center;
    background-size: cover;
  }
`,
);

export const StyledAsideList = styled(List)<{ component?: React.ElementType }>({
  '& .MuiListItemButton-root': {
    color: '#fff',
    fontWeight: 400,
  },
  '& .MuiListItemIcon-root': {
    '& .MuiSvgIcon-root': {
      color: '#888F99',
    },
  },
  '& .MuiSvgIcon-root': {
    color: '#fff',
  },
});
